/**
 * @author Govind Dindewad
 * @description INCSUBSettings Component - Allows users to view and manage settings like changing passwords.
 */

import React, { useState } from 'react';
import './settings.css';
import INCSUBButton from '../common/Button/INCSUBButton';
import ChangePassword from './ChangePassword';

function INCSUBSettings() {
  const user = JSON.parse(window.localStorage.getItem('userData'));
  const [isOpenPassScreen, setIsOpenPassScreen] = useState(false);

  /**
   * @function changePassScreen
   * @description Toggles the state to show/hide the Change Password component.
   */
  const changePassScreen = () => {
    setIsOpenPassScreen(prev => !prev);
  };

  /**
   * @function convertDateFormat
   * @description Converts date string into a user-friendly format.
   * @param {string} date - Date string in ISO format (e.g., "2025-01-09T18:51:36")
   * @returns {string} - Formatted date string (e.g., "January 9, 2025")
   */
  const convertDateFormat = (date) => {
    const dateObj = new Date(date);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return dateObj.toLocaleDateString('en-US', options);
  };

  return (
    <div className='INCSUBSettings_ctn'>
      {/* Left Panel */}
      <div className='INCSUBSettings_leftcard'>
        <div className='INCSUBSettings_leftcard_heading'>
          <div className='INCSUBSettings_leftcard_heading_text'>Settings</div>
          <div className='INCSUBSettings_leftcard_heading_text_desc'>
            Here you can change and edit your needs
          </div>
        </div>
        <div className='INCSUBSettings_leftcard_imgholder'>
          <img src='/assets/images/user/settingLeftCardImg.svg' alt='Settings Illustration' />
        </div>
        <div className='INCSUBSettings_leftcard_dropdawn'>
          Security
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18.5L15 12.5L9 6.5" stroke="#4880FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        {/* <div className='INCSUBSettings_leftcard_dropdawn' style={{ color: '#202224' }}>
          Upcoming Settings
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18.5L15 12.5L9 6.5" stroke="#797A7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div> */}
      </div>

      {/* Right Panel */}
      <div className='INCSUBSettings_rightcard'>
        <div className='INCSUBSettings_rightcard_card'>
          <div className='INCSUBSettings_rightcard_heading'>
            <div className='INCSUBSettings_leftcard_heading_text'>Change Password</div>
            <div className='INCSUBSettings_leftcard_heading_text_desc'>
              Set a unique password to protect your account.
            </div>
          </div>
          <div className='INCSUBSettings_rightcard_btns'>
            Last Changed:{' '}
            {user && user !== 'null' ? convertDateFormat(user.userPasswordUpdatedAt) : 'N/A'}
            <INCSUBButton text={'Change Password'} clickFun={changePassScreen} />
          </div>
        </div>
      </div>

      {/* Modal for Change Password */}
      {isOpenPassScreen && <ChangePassword handleScreenOpen={changePassScreen} />}
    </div>
  );
}

export default INCSUBSettings;
